export default "__VITE_ASSET__BpXo9TWU__"